// src/store/modules/pdf.js
// Vuex module that wraps the canonical JSON-based PdfService facade.
// Actions: generate (returns Blob), download (saves file), open (opens in new tab)

import { PdfService } from '@/Services/pdf/PdfService';

export default {
  namespaced: true,
  actions: {
    /**
     * @param _
     * @param {{ model: Object }} payload
     * @returns {Promise<Blob>}
     */
    async generate(_, { model }) {
      try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][vuex] generate', { hasContent: Array.isArray(model?.content), contentLength: model?.content?.length }); } catch(_){}
      const t0 = Date.now();
      const blob = await PdfService.render(model);
      try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][vuex] generate: done', { ms: Date.now() - t0, size: blob?.size }); } catch(_){}
      return blob;
    },
    /**
     * @param _
     * @param {{ model: Object, filename?: string }} payload
     * @returns {Promise<void>}
     */
    async download(_, { model, filename = 'document.pdf' }) {
      try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][vuex] download', { filename }); } catch(_){}
      const t0 = Date.now();
      await PdfService.download(model, filename);
      try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][vuex] download: done', { filename, ms: Date.now() - t0 }); } catch(_){}
    },
    /**
     * @param _
     * @param {{ model: Object }} payload
     * @returns {Promise<void>}
     */
    async open(_, { model }) {
      try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][vuex] open'); } catch(_){}
      const t0 = Date.now();
      await PdfService.openInNewTab(model);
      try { if (typeof window !== 'undefined' && window.PDF_DEBUG !== false) console.log('[PDF][vuex] open: done', { ms: Date.now() - t0 }); } catch(_){}
    },
  },
};
